import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioClassificacaoReducer(state = initialState.relatorioClassificacao, action){
    switch(action.type) {
        case types.RELAT_CLASSIFICACAO_ESTRUTURA:
            
            return action.relatorioClassificacao;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioClassificacaoReducer.js
 **/